import { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GetOverviewReport } from "./queries";
import { endOfDate } from "../../helpers/DateManipulation";
import _ from "lodash";
import moment from "moment";
import { useHistory } from "react-router-dom";

export default function useOverviewReport() {
  const history = useHistory();

  const [filters, setFilters] = useState({
    date: [
      moment()
        .subtract(3, "months")
        .toDate(),
      new Date()
    ]
  });
  const [products, setProducts] = useState([]);
  const [videos, setVideos] = useState([]);

  const { loading, data, error } = useQuery(GetOverviewReport, {
    variables: {
      productId: filters.productId && filters.productId.key,
      videoId: filters.videoId && filters.videoId.key,
      date: {
        greaterThanOrEqual: filters.date[0].toUTCString(),
        lessThanOrEqual: endOfDate(filters.date[1]).toUTCString()
      }
    }
  });

  if (!!error) history.push("/");

  const filterOptions = buildFilterOptions({
    products,
    videos
  });

  useEffect(() => {
    if (
      !loading &&
      data &&
      data.reports &&
      !products.length &&
      !videos.length
    ) {
      setProducts(data.reports.overviewReport.productList);
      setVideos(data.reports.overviewReport.videoList);
    }
  }, [data]);

  return {
    loading: loading || error,
    overviewReport:
      loading || error || !data ? undefined : data.reports.overviewReport,
    filters,
    filterOptions,
    setFilters
  };
}

const buildFilterOptions = ({ products, videos }) => [
  {
    key: "productId",
    label: "Product",
    type: "menu",
    options: _.uniqBy(products, "id").map((product) => ({
      key: product.id,
      label: product.name
    })),
    filter: true
  },
  {
    key: "date",
    label: "Date Range",
    type: "dateRange",
    required: true
  },
  {
    key: "videoId",
    label: "Video",
    type: "menu",
    options: _.uniqBy(videos, "id").map((video) => ({
      key: video.id,
      label: video.name
    })),
    filter: true
  }
];
